(() => {
  const mql = window.matchMedia('(pointer: coarse) and (max-width: 999px)');
  const OUTER_SELECTOR =
    '.product-list--carousel, .sm-max\\:product-list--carousel, .md-max\\:product-list--carousel';
  const HORIZ_THRESHOLD = 6;
  const state = new WeakMap();

  document.addEventListener(
    'touchstart',
    (e) => {
      if (!mql.matches) return;
      const inner = e.target.closest('.product-card__carousel');
      if (!inner) return;
      const outer = inner.closest(OUTER_SELECTOR);
      if (!outer) return;
      const t = e.touches[0];
      state.set(inner, {
        startX: t.clientX,
        startY: t.clientY,
        lastX: t.clientX,
        outer,
        decided: null,
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (e) => {
      const inner = e.target.closest('.product-card__carousel');
      if (!inner) return;
      const s = state.get(inner);
      if (!s) return;
      const t = e.touches[0];
      const dx = t.clientX - s.startX;
      const dy = t.clientY - s.startY;

      if (s.decided === null) {
        if (Math.abs(dx) < HORIZ_THRESHOLD && Math.abs(dy) < HORIZ_THRESHOLD) return;
        s.decided = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      }

      if (s.decided === 'h') {
        s.outer.scrollLeft += s.lastX - t.clientX;
        s.lastX = t.clientX;
        if (e.cancelable) e.preventDefault();
      }
    },
    { passive: false }
  );

  const clear = (e) => {
    const inner = e.target.closest?.('.product-card__carousel');
    if (inner) state.delete(inner);
  };
  document.addEventListener('touchend', clear, { passive: true });
  document.addEventListener('touchcancel', clear, { passive: true });
})();
